var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicedtech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.923,
    height: 40,
    viewBox: "0 0 87.923 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(135.285 -87.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(-135.285 87.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M194.035,449.13h9.674v-3.02h-9.674V441.4h12.654v-3.064H193.3a2.5,2.5,0,0,0-2.5,2.5v13.855a2.5,2.5,0,0,0,2.5,2.5H206.69l0-3.064H194.035Z",
    transform: "translate(-190.801 -417.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M704.017,489.487a4.1,4.1,0,1,1,0-8.206,3.628,3.628,0,0,1,3.347,2.091l3.137-.559a6.918,6.918,0,0,0-6.484-4.569,7.14,7.14,0,0,0,0,14.279,6.944,6.944,0,0,0,3.882-1.146,7.448,7.448,0,0,0,2.833-3.827h-3.258A4.054,4.054,0,0,1,704.017,489.487Z",
    transform: "translate(-638.524 -452.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M339.156,453.6V438.335H335.92v6.248a5.975,5.975,0,0,0-4.1-1.5,7.14,7.14,0,0,0,0,14.279,5.9,5.9,0,0,0,4.482-1.933c.016-.018.024-.028.039-.029s.022.009.027.033a2.7,2.7,0,0,0,.33.812,2.129,2.129,0,0,0,2.044.934l1.4,0,.913-2.824h-1.1A.7.7,0,0,1,339.156,453.6Zm-2.937-3.373a4.252,4.252,0,1,1,0-.007Z",
    transform: "translate(-309.258 -417.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M475.445,438.335H458.957v2.8h6.627v16.044h3.234V441.139h6.627Z",
    transform: "translate(-428.072 -417.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M570.43,478.245a7.187,7.187,0,0,0-7.14,7.14c-.062,4.057,2.991,7.142,7.391,7.139,4.259,0,6.062-2.364,6.651-3.626l-3.056-.811a3.993,3.993,0,0,1-3.632,1.554,4.047,4.047,0,0,1-4.155-3.009h11.024a10.229,10.229,0,0,0,.057-1.248A6.971,6.971,0,0,0,570.43,478.245Zm-3.856,5.591.013-.035a4.158,4.158,0,0,1,7.771.011l.007.025Z",
    transform: "translate(-520.347 -452.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_572-2",
    "data-name": "Group 572",
    transform: "translate(12.677 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M840.315,308.478a6.943,6.943,0,0,0,3.882-1.146,7.447,7.447,0,0,0,2.832-3.827h-3.258a4.054,4.054,0,0,1-3.457,1.936,4.1,4.1,0,0,1,0-8.206,3.628,3.628,0,0,1,3.347,2.091l3.137-.559a6.918,6.918,0,0,0-6.484-4.569,7.14,7.14,0,0,0,0,14.279Z",
    transform: "translate(-771.783 -289.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M507.187,308.547a5.888,5.888,0,0,0,4.334-1.931c.016-.018.024-.028.039-.029s.022.009.027.033a2.7,2.7,0,0,0,.33.812,2.129,2.129,0,0,0,2.045.934l1.4,0,.913-2.824h-1.1a.7.7,0,0,1-.8-.757V294.449h-3.236v1.431a.025.025,0,0,1-.042.018,5.917,5.917,0,0,0-4.245-1.629,7.141,7.141,0,0,0,.333,14.277Zm0-11.39a4.252,4.252,0,0,1,4.252,4.249v.007a4.252,4.252,0,1,1-4.252-4.256Z",
    transform: "translate(-476.727 -289.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1565",
    "data-name": "Rectangle 1565",
    width: 3.235,
    height: 3.235,
    transform: "translate(57.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    width: 3.234,
    height: 13.917,
    transform: "translate(57.067 5.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M302.262,262.633l4.458,8.027H310.4l4.458-8.027c.82-1.495,1.479-2.7,1.659-3.033a.026.026,0,0,1,.049.013v13.152H319.8V256.239a2.156,2.156,0,0,0-2.194-2.372c-.852,0-1.459.318-2.273,1.627l-6.771,11.754-6.771-11.754c-.814-1.309-1.421-1.627-2.273-1.627a2.156,2.156,0,0,0-2.194,2.372v16.526h3.234V259.613a.026.026,0,0,1,.049-.013C300.782,259.93,301.441,261.138,302.262,262.633Z",
    transform: "translate(-297.319 -253.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M646.168,308.322a5.82,5.82,0,0,0,2.857-.693,4.89,4.89,0,0,0,1.378-1.145.022.022,0,0,1,.041.014v2.018a2.635,2.635,0,0,1-.729,2.013,2.8,2.8,0,0,1-2.152.7h-6.724a.017.017,0,0,0-.017.017v2.775a.017.017,0,0,0,.017.017h7.192a5.154,5.154,0,0,0,4.063-1.63,5.424,5.424,0,0,0,1.284-3.855V297.79a.683.683,0,0,1,.754-.724h.825a.017.017,0,0,0,.016-.012l.9-2.8a.017.017,0,0,0-.016-.022h-2.519a2.189,2.189,0,0,0-2.064.937,3.084,3.084,0,0,0-.341.812c0,.025-.016.034-.026.033s-.022-.012-.04-.029a6.967,6.967,0,0,0-1.562-1.187,6.021,6.021,0,0,0-2.349-.727,7.145,7.145,0,1,0-.792,14.246Zm-4.064-7.987a4.256,4.256,0,1,1,5.018,5.018A4.223,4.223,0,0,1,642.1,300.336Z",
    transform: "translate(-599.955 -289.155)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M835.936,443.958a6.42,6.42,0,0,0-7.463.431v-6.054h-3.234v18.848h3.234v-7.719a3.461,3.461,0,0,1,3.272-3.523c2.4-.089,3.664,1.448,3.664,3.681v7.561h3.234V449.4A6.2,6.2,0,0,0,835.936,443.958Z",
    transform: "translate(-752.114 -417.364)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicedtech);
export default __webpack_public_path__ + "static/media/magicedtech.9efb6b4e4f3127429ced1b47b33b21af.svg";
export { ForwardRef as ReactComponent };